import { competitorMediaEffectQueryOptions } from '@/dashboards/CompetitorsMediaInvestment/api';
import { getCompetitorEffectVariables } from '@/dashboards/CompetitorsMediaInvestment/helpers/getCompetitorEffectVariables';
import { useCompetitorsMediaInvestmentUrl } from '@/dashboards/CompetitorsMediaInvestment/hooks/useCompetitorsMediaInvestmentUrl';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { useDuckDBQuery } from '@/duckdb';

export const useCompetitorMediaEffectQuery = () => {
    const { search } = useCompetitorsMediaInvestmentUrl();
    const { period, startDate, endDate } = search;

    const {
        dashboard: { dashboardVariables },
    } = useDashboardGlobalContext();

    const competitorImpactVariables: string[] =
        getCompetitorEffectVariables(dashboardVariables);

    const queryResult = useDuckDBQuery(
        competitorMediaEffectQueryOptions({
            competitorImpactVariables,
            period,
            startDate,
            endDate,
        }),
    );

    return {
        queryResult,
    };
};
